import { Card, message } from "antd";
import React from "react";
import DraggablecompTI from "../Common/DraggablecompTI";
import { useSelector } from "react-redux";
import { selectStepReflections } from "slices/dashboardSlice";
import useCustomizeDash from "hooks/useCustomizeDash";
import HELPERS from "utils/helper";
import DASHBOARD_API from "api/dashboard";

const Targetindustriescard = ({setLeftSections, setRightSections, compID, left, tmpState, setTmpState}) => {
  const stepReflections = useSelector(selectStepReflections);
  const { isDropdownOpen } = useCustomizeDash();
  const userId = HELPERS.getUserId();

  const stepReflectionsStepId = (step) =>
    stepReflections[step] ? stepReflections[step].id : null;

  const isDone = (step) => 
    stepReflections[step] ? stepReflections[step].status === "DO" || stepReflections[step].status === "RE" : false;

  const handleDelete = () => {
    // left ? setLeftSections((prev) => prev.filter((section) => section.id !== compID)) : setRightSections((prev) => prev.filter((section) => section.id !== compID));
    try {
      const payload = { "step_id": compID, "user_id": userId }
      console.log("sss delete", payload);
      DASHBOARD_API.deleteDashboardItem(payload)
      .then((response) => {
        console.log("sss delete api response", response);
        message.success("Your work has been saved")
        setTmpState(!tmpState)
      })
      .catch((err) => {
        console.log("sss delete api error", err, payload);
        message.error("Your work has not been saved")
      });
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };
  
  return (
    <Card
      bordered={false}
      style={{
        boxShadow: "0px 3px 16px 0px #1313131A",
        borderRadius: "12px",
        textAlign: "left",
        margin: "0px 20px",
        height: "fit-content",
      }}
    >
      <div className="h" style={{ fontWeight: "bold", textAlign: "left" }}>
        <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "10.5px",
          }}
        >
          <div className="my-target-industry">

            {/* Future Release Build */}
            <img src="https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/dashboardMyTasksDrag.svg" className="" /> 
            <span className="my-target-industries-title">My Target Industries</span>
          </div>
          {isDropdownOpen ? (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "10.5px",
              }}
            >
              <img
                src="https://django-woken-static.s3.amazonaws.com/static/media/compRemove.svg"
                alt="delete icon"
                className="delete-icon"
                style={{
                  cursor: "pointer",
                }}
                onClick={handleDelete}
              />
            </div>
          ) : null 
          }
        </div>
      </div>
      <div style={{ marginTop:"40px"}}>
        <DraggablecompTI isDone={isDone('TI')} buttonVisible={false} />
        {/* <DraggablecompTI isDone={( isDone('TI') && isDone('AS') ) || isDone('TI')} buttonVisible={false} /> */}
        {/* <DraggablecompTI isDone={true} buttonVisible={false} /> */}
        
      </div>
    </Card>
  );
};

export default Targetindustriescard;